import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";

import {
  getSettingState,
  setTableModalTab,
  setThoughtTab,
} from "../../../redux/features/settingSlice";
import CustomButton from "./../CustomButton/index";
import useFollow from "../../../hooks/UseFollow";
import { fetcherGetToken } from "../../../services/fetcher";
import useEnroll from "./../../../hooks/UseEnroll/index";

const EmptyState = ({ title, dis, btn1, btn2 }) => {
  const [btnText1, setBtnText1] = useState(null);
  const [btnText2, setBtnText2] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const { userData } = useSelector(getSettingState);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { data: profile } = useSWR(() => {
    if (urlParams[1] !== "profile" || !urlParams[2]) {
      return null;
    }
    return [
      process.env.REACT_APP_API + `/auth/v2/profile/${urlParams[2]}/`,
      tokenStorage,
    ];
  }, fetcherGetToken);

  const [, setFollowBtn] = useState(profile?.followed);
  const [handleFollowBtn] = useFollow(profile, false, setFollowBtn);
  const [, setEnrollBtn] = useState(false);
  const [handleEnrollBtn] = useEnroll(params.tableId, false, setEnrollBtn);

  const handleButtonText = () => {
    if (btn1) {
      if (btn1.toLowerCase() === "table") {
        setBtnText1("Find a table");
      }
      if (btn1.toLowerCase() === "discussions") {
        setBtnText1("Discussions");
      }
      if (btn1.toLowerCase() === "opinions") {
        setBtnText1("Opinions");
      }
    }

    if (btn2) {
      if (btn2.toLowerCase() === "enroll") {
        // if (!table?.enrolled) {
        setBtnText2("Enroll");
        // }
      }
      if (btn2.toLowerCase() === "follow") {
        setBtnText2("Follow");
      }
      if (btn2.toLowerCase() === "discussions") {
        setBtnText2("Discussions");
      }
      if (btn2.toLowerCase() === "opinions") {
        setBtnText2("Opinions");
      }
      if (btn2.toLowerCase() === "login") {
        setBtnText2("Login");
      }
    }
  };

  const handleOnclickBtn1 = () => {
    if (btn1) {
      if (btn1.toLowerCase() === "table") {
        navigate("/explore");
      }
      if (btn1.toLowerCase() === "discussions") {
        navigate("/table/" + params.tableId);
        dispatch(setTableModalTab(0));
        dispatch(setThoughtTab(0));
      }
      if (btn1.toLowerCase() === "opinions") {
        navigate("/table/" + params.tableId);
        dispatch(setTableModalTab(0));
        dispatch(setThoughtTab(1));
      }
    }
  };

  const handleOnclickBtn2 = () => {
    if (btn2) {
      if (btn2.toLowerCase() === "enroll") {
        handleEnrollBtn();
      }
      if (btn2.toLowerCase() === "follow") {
        handleFollowBtn();
      }
      if (btn2.toLowerCase() === "discussions") {
        navigate("/table/" + params.tableId);
        dispatch(setTableModalTab(0));
        dispatch(setThoughtTab(0));
      }
      if (btn2.toLowerCase() === "opinions") {
        navigate("/table/" + params.tableId);
        dispatch(setTableModalTab(0));
        dispatch(setThoughtTab(1));
      }
      if (btn2.toLowerCase() === "login") {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    handleButtonText();

    return () => {
      setBtnText1("");
      setBtnText2("");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, location.pathname, title, dis, btn1, btn2, profile]);

  return (
    <Box sx={{ pt: "40px", pb: "45px", height: "100%" }}>
      {title && (
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontSize: "32px",
            lineHeight: "32px",
            fontWeight: 500,
            mb: "16px",
          }}
        >
          {title}
        </Typography>
      )}

      {dis && (
        <Typography
          sx={{
            fontSize: "18px",
            lineHeight: "28px",
            color: "gray.main",
          }}
        >
          {dis}
        </Typography>
      )}
      <Box sx={{ display: "flex", mt: "16px" }}>
        {btnText1 && (
          <CustomButton
            title={btnText1}
            onClick={handleOnclickBtn1}
            fSize='16px'
            width='100%'
            height='40px'
            bShadow='0px'
            bgColor='white.main'
          />
        )}
        {btnText2 && (
          <CustomButton
            title={btnText2}
            onClick={handleOnclickBtn2}
            fSize='16px'
            width='100%'
            height='40px'
            bShadow='4px'
            bgColor='primary.main'
            mLeft={btnText2 ? "16px" : ""}
          />
        )}
      </Box>
    </Box>
  );
};

export default EmptyState;
